export default __webpack_public_path__ + "static/media/reset password.1610bb9c.png";